import React from 'react';

import { graphql, usePreloadedQuery, type EntryPointProps } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import type { SubspaceMenuListQuery } from './__generated__/SubspaceMenuListQuery.graphql.ts';
import { SubspaceMenuList } from './SubspaceMenuList.tsx';

type Queries = {
	projects: SubspaceMenuListQuery;
};

export default function SubspaceMenuListQuery({
	queries: { projects },
}: EntryPointProps<Queries, {}, EntryPointRouteParams, {}>): React.JSX.Element {
	const data = usePreloadedQuery<SubspaceMenuListQuery>(
		graphql`
			query SubspaceMenuListQuery($cloudId: ID!, $projectKey: String!) @preloadable {
				jira @required(action: THROW) {
					jiraProjectByKey(cloudId: $cloudId, key: $projectKey) @required(action: THROW) {
						...SubspaceMenuList
					}
				}
			}
		`,
		projects,
	);

	return <SubspaceMenuList queryRef={data.jira.jiraProjectByKey} />;
}
